/**
 * Query key factory for AI config readiness.
 * Follows the same pattern as llm-providers.keys.ts.
 *
 * Consumers: useAiConfigReadiness hook + all LLM-mutating hooks that
 * invalidate readiness on settle (provider create/update/delete/verify,
 * org default set).
 */
export const aiconfigKeys = {
  all: ["aiconfig"] as const,
  readiness: () => [...aiconfigKeys.all, "readiness"] as const,
};
